import Media from 'react-media';
import { css, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { vars } from '@etg/wings';
import type { TripCampaignType } from '../../../../models';

const campaignImageStyle = css`
  border-bottom-left-radius: ${vars.card.borderRadius};
  border-bottom-right-radius: ${vars.card.borderRadius};
  display: block;
  width: 100%;
`;

interface TripCampaignProps {
  tripCampaign: NonNullable<TripCampaignType>;
}

export const TripCampaign = ({ tripCampaign }: TripCampaignProps) => {
  const { t } = useTranslation();
  return (
    <Media query={mediaQueries.medium.up}>
      {(matches) => (
        <img
          alt={t('Result.Campaigns.AltText')}
          className={campaignImageStyle}
          data-testid="trip-campaign"
          src={matches ? tripCampaign.campaignImageUrlDesktop : tripCampaign.campaignImageUrlMobile}
        />
      )}
    </Media>
  );
};
